import { render, staticRenderFns } from "./ProjectTabFiles.vue?vue&type=template&id=242c4887&scoped=true&"
import script from "./ProjectTabFiles.vue?vue&type=script&lang=js&"
export * from "./ProjectTabFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242c4887",
  null
  
)

export default component.exports